import { Box, Typography } from '@mui/material';

const TshirtIconComponent = ({
    primary,
    number,
    colorNumber,
    width = '70px',
    height = '70px',
    fontSize = '12px',
}) => {
    return (
        <Box
            style={{
                width: width,
                height: height,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '4px',
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 512 512">
                <path
                    d="M480 96L320 48c-13.988 27.227-30.771 40.223-63.769 40.223C223.723 87.676 205.722 75 192 48L32 96l32 88 64-8-16 288h288l-16-288 64 8 32-88z"
                    fill={primary}
                />
            </svg>
            <Typography
                sx={{
                    fontSize: fontSize,
                    position: 'absolute',
                    color: colorNumber,
                }}
            >
                {number}
            </Typography>
        </Box>
    );
};

export default TshirtIconComponent;
